<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script>
// 用于自定义菜单节点
export default {
    name: `CustomizeMenu`,
    props: {

    },
    data() {
        return {
            title: `自定义菜单`
        }
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/LayoutMenu.vue